import { Component } from '@angular/core';

/**
 * @internal
 * Used as a wrapper for value groups
 */
@Component({
  selector: 'app-value-group',
  imports: [],
  templateUrl: './value-group.component.html',
  styleUrl: './value-group.component.css'
})
export class ValueGroupComponent {

}
